module.exports = __webpack_public_path__ + "media/200513_YEAH_CI_neuer_Look_Cloner_Falloff.d0a52454.mp4";